export class DocSplitInfo {
  newDocumentName!: string;
  pageNumbers!: number[];
}
